import { render, staticRenderFns } from "./calendar-event-title.vue?vue&type=template&id=559344ea&scoped=true"
import script from "./calendar-event-title.vue?vue&type=script&lang=js"
export * from "./calendar-event-title.vue?vue&type=script&lang=js"
import style0 from "./calendar-event-title.vue?vue&type=style&index=0&id=559344ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559344ea",
  null
  
)

export default component.exports